import { Box } from '@mui/material';
import React from 'react';
import { InitialRoutes } from 'routes';

function App() {
  return (
    <Box sx={{ overflowY: 'auto', minHeight: '100vh' }}>
      <InitialRoutes />
    </Box>
  );
}

export default App;
